import React, { useEffect, useState, useContext } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import '../../views/container/cms/content.scss'
import useAxios from 'axios-hooks'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loading from 'react-fullscreen-loading'
import { GlobalContext } from 'src/views/context/GlobalState'
import { AppContext } from 'src/views/context/app'
import {
  CONTENT_LIST_FILTER_API,
  SUBSCRIPTION_API,
  ARTIST_LIST_API,
  META_DATA_URL,
} from 'src/views/utils/urls'
import { isEmpty, getThumbnail, convertDuration, raiseToast } from 'src/views/utils/helper'
import { capitalize, isArray } from 'lodash'
import moment from 'moment'
import CustomListCard from 'src/views/container/AssetManager/customListCard'
import CustomCard from 'src/views/container/AssetManager/customCard'
import GridViewIcon from '../../assets/Content-Icons/Svgs/grid-view-icon.svg'
import ListViewIcon from '../../assets/Content-Icons/Svgs/list-view-icon.svg'
import AssetFilter from 'src/views/container/AssetManager/AssetFilter'
import PreviewDetails from 'src/views/container/AssetManager/PreviewDetails'
import CustomPreviewListCard from 'src/views/container/AssetManager/customPreviewListCard'

const ContentModalNew = () => {
  const { setLoader, loader, contentModalNewProps, setContentModalNewProps } =
    useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)

  const { selectCallback, type, mappedContentId, mappedContentArray } = contentModalNewProps
  const [selectedContentId, setSelectedContentId] = useState(
    type === 'single' ? `${mappedContentId}` : [...mappedContentId],
  )
  const [selectedContents, setSelectedContents] = useState([])

  const [contentData, setContentData] = useState([])
  const [searchText, setSearchText] = useState('')

  const [page, setPage] = useState(1)
  const [listView, setListView] = useState(false)
  const [previewContent, setPreviewContent] = useState({})
  const [filters, setFilters] = useState([])
  const [filterPayloadObj, setFilterPayloadObj] = useState({
    video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
  })
  const [categoryFilter, setCategoryFilter] = useState([])
  const [subCategoryFilter, setSubCategoryFilter] = useState([])
  const [subscriptionFilter, setSubcriptionFilter] = useState([])
  const [PPVFilter, setPPVFilter] = useState([])
  const [artistFilter, setArtistFilter] = useState([])
  const [categoryMasterData, setCategoryMasterData] = useState([])
  const [subCategoryMasterData, setSubCategoryMasterData] = useState([])
  const [subscriptionMasterData, setSubscriptionMasterData] = useState([])
  const [ppvMasterData, setPPVMasterData] = useState([])
  const [artistData, setArtistData] = useState([])
  const [basicInfo, setBasicInfo] = useState([])

  const [listContentMode, setListContentMode] = useState(false)

  const [{ data: categories, loading: categoriesLoading }] = useAxios({
    url: `${META_DATA_URL}/system`,
    method: 'get',
  })

  const [{ data: subscriptionList, loading: subscriptionListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=normal',
    method: 'get',
  })

  const [{ data: ppvList, loading: ppvListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=ppv',
    method: 'get',
  })

  const [{ data: artist, loading: artistLoading }] = useAxios({
    url: ARTIST_LIST_API,
    method: 'get',
  })

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_LIST_FILTER_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ loading: editContentListLoading }, editContentListCall] = useAxios(
    {
      url: CONTENT_LIST_FILTER_API,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(async () => {
    if (!isEmpty(mappedContentId) && !isEmpty(contentData)) {
      let contents = await editContentListCall({
        data: {
          filters: {
            content_ids: type === 'single' ? [`${mappedContentId}`] : [...mappedContentId],
          },
          page: 1,
          order_by: 'modified_date',
          page_size: type === 'single' ? 1 : mappedContentId.length,
        },
      })
      setSelectedContents(contents?.data?.data)
    }
  }, [mappedContentId, contentData])

  useEffect(() => {
    if (categories && categories.success) {
      setCategoryMasterData(
        categories?.data?.filter((info) => info.status && info.type === 'category'),
      )
      setSubCategoryMasterData(
        categories?.data?.filter((info) => info.status && info.type === 'sub_category'),
      )
    }
  }, [categories])

  useEffect(() => {
    if (subscriptionList && subscriptionList.success) {
      setSubscriptionMasterData(subscriptionList?.data?.filter((info) => info.status))
    }
  }, [subscriptionList])

  useEffect(() => {
    if (ppvList && ppvList.success) {
      setPPVMasterData(ppvList?.data?.filter((info) => info.status))
    }
  }, [ppvList])

  useEffect(() => {
    if (artist && artist.success) {
      setArtistData(artist?.data?.filter((info) => info.status))
    }
  }, [artist])

  useEffect(() => {
    setFilterPayloadObj({
      system_defined: [
        {
          key: 'category',
          name: 'Category',
          filter_type: 'AND',
          operator: 'eq',
          values: categoryFilter,
        },
        {
          key: 'sub_categories',
          name: 'Sub-Category',
          filter_type: 'AND',
          operator: 'eq',
          values: subCategoryFilter,
        },
        {
          key: 'active_subscription',
          name: 'Subscription',
          filter_type: 'AND',
          operator: 'eq',
          values: subscriptionFilter,
        },
        {
          key: 'active_ppv',
          name: 'PPV',
          filter_type: 'AND',
          operator: 'eq',
          values: PPVFilter,
        },
        {
          key: 'artists',
          name: 'Artist',
          filter_type: 'AND',
          operator: 'eq',
          values: artistFilter,
        },
      ],
      video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
      search_text: searchText,
    })
  }, [searchText, artistFilter, PPVFilter, subscriptionFilter, subCategoryFilter, categoryFilter])

  useEffect(() => {
    if (filters.filter((info) => info.checkedState !== '').length === 0) {
      setFilters([
        {
          title: 'Category',
          type: 'checkbox',
          checkedState: '',
          options: categoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            //  index, setStateFunc, checked, value
            onFilterChange(0, setCategoryFilter, checked, value)
          },
        },
        {
          title: 'Sub Category',
          type: 'checkbox',
          checkedState: '',
          options: subCategoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(1, setSubCategoryFilter, checked, value)
          },
        },
        {
          title: 'Subscription',
          type: 'checkbox',
          checkedState: '',
          options: subscriptionMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(2, setSubcriptionFilter, checked, value)
          },
        },
        {
          title: 'PPV',
          type: 'checkbox',
          checkedState: '',
          options: ppvMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(3, setPPVFilter, checked, value)
          },
        },
        {
          title: 'Artists',
          type: 'checkbox',
          checkedState: '',
          options: artistData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(4, setArtistFilter, checked, value)
          },
        },
      ])
    }
  }, [categoryMasterData, subCategoryMasterData, subscriptionMasterData, ppvMasterData, artistData])

  const filterIntialValue = [
    {
      title: 'Category',
      type: 'checkbox',
      checkedState: '',
      options: categoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        //  index, setStateFunc, checked, value
        onFilterChange(0, setCategoryFilter, checked, value)
      },
    },
    {
      title: 'Sub Category',
      type: 'checkbox',
      checkedState: '',
      options: subCategoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(1, setSubCategoryFilter, checked, value)
      },
    },
    {
      title: 'Subscription',
      type: 'checkbox',
      checkedState: '',
      options: subscriptionMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(2, setSubcriptionFilter, checked, value)
      },
    },
    {
      title: 'PPV',
      type: 'checkbox',
      checkedState: '',
      options: ppvMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(3, setPPVFilter, checked, value)
      },
    },
    {
      title: 'Artists',
      type: 'checkbox',
      checkedState: '',
      options: artistData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(4, setArtistFilter, checked, value)
      },
    },
  ]

  useEffect(() => {
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: page,
        order_by: 'modified_date',
        page_size: 24,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(
      contentListLoading ||
        categoriesLoading ||
        artistLoading ||
        subscriptionListLoading ||
        ppvListLoading ||
        editContentListLoading,
    )
  }, [
    contentListLoading,
    categoriesLoading,
    artistLoading,
    subscriptionListLoading,
    ppvListLoading,
    editContentListLoading,
  ])

  useEffect(() => {
    if (contentList && contentList.success) {
      page === 1
        ? setContentData(contentList.data)
        : setContentData((contentData) => [...contentData, ...contentList.data])
    }
  }, [contentList])

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Title',
        value: previewContent.title,
      },
      {
        property: 'Description',
        value: previewContent?.description,
      },
      {
        property: 'Content Type',
        value: previewContent?.video_type,
      },
      {
        property: 'File Type',
        value: previewContent?.asset_type,
      },

      {
        property: 'Category',
        value: !isEmpty(previewContent?.category)
          ? [...previewContent?.category].map((info) => info.name).toString()
          : '',
      },
      { property: 'Status', value: capitalize(String(previewContent?.publish_policy)) },
      {
        property: 'Monetization',
        value:
          previewContent?.active_subscription?.length > 0 ||
          previewContent?.active_ppv_subscription?.length > 0
            ? 'Paid'
            : 'Free',
      },
      {
        property: 'Publish Time',
        value: moment(previewContent?.publish_time).format('DD MMM YYYY'),
      },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [previewContent])

  const onFilterChange = (index, setStateFunc, checked, value) => {
    if (checked) {
      setStateFunc((prev) => {
        handleFilterChange(index, [...prev, value])
        return [...prev, value]
      })
    } else {
      setStateFunc((prev) => {
        handleFilterChange(
          index,
          [...prev].filter((type) => type !== value),
        )
        return [...prev].filter((type) => type !== value)
      })
    }
  }

  const handleFilterChange = (index, value) => {
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    contentListCall({
      data: {
        filters: { ...filterPayloadObj, search_text: value },
        page: 1,
        order_by: 'modified_date',
        page_size: 24,
      },
    })
  }

  const handleNextPage = () => {
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: page + 1,
        order_by: 'modified_date',
        page_size: 24,
      },
    })
    setPage((page) => page + 1)
  }

  const applyFilter = () => {
    setPage(1)
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: 1,
        order_by: 'modified_date',
        page_size: 24,
      },
    })
  }

  const resetFilters = () => {
    setFilters(filterIntialValue)
    setCategoryFilter([])
    setSubCategoryFilter([])
    setSubcriptionFilter([])
    setPPVFilter([])
    setArtistFilter([])
    setPage(1)
    contentListCall({
      data: {
        filters: {
          search_text: searchText,
          video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
        },
        page: 1,
        order_by: 'modified_date',
        page_size: 24,
      },
    })
  }

  const handleContentSelect = (info) => {
    if (type === 'single') {
      info._id === selectedContentId ? setSelectedContentId('') : setSelectedContentId(info._id)
      let temp = []
      temp.push(info)
      setSelectedContents(temp)
      return
    }
    let tempArr = selectedContents
    let temp = selectedContentId
    let contentIndex = selectedContentId.findIndex((e) => e === info._id)
    if (contentIndex > -1) {
      temp = selectedContentId.filter((e) => e !== info._id)
      tempArr = selectedContents.filter((e) => e._id !== info._id)
    } else {
      temp.push(info._id)
      tempArr.push(info)
    }

    setSelectedContents([...tempArr])
    setSelectedContentId([...temp])
  }

  // const handleActiveClasses = (info) => {
  //   let flag = false
  //   if (type === 'single') {
  //     flag = info._id === selectedContentId
  //   } else {
  //     flag = selectedContentId.findIndex((e) => e === info._id) > -1
  //   }

  //   return flag
  // }

  const handleSelect = () => {
    if (!isEmpty(selectedContentId)) {
      selectCallback(selectedContentId, selectedContents)
      setContentModalNewProps({})
    }
  }

  const handleRemoveContent = (id) => {
    const tempData = selectedContents.filter((item) => item?._id !== id)
    setSelectedContents([...tempData])
  }

  const handleContentMode = () => {
    if (isEmpty(selectedContentId)) {
      raiseToast('error', 'Please Select a content!')
      return
    }
    setListContentMode(true)
  }
  return (
    <CModal size="lg" className="content-modal" alignment="center" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />

      {!isEmpty(previewContent) && (
        <PreviewDetails
          onClose={() => setPreviewContent({})}
          cardImage={getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            previewContent?.thumbnail?.website?.s3_key,
          )}
          headline="Content Preview"
          subHeadline="Detailed information about the selected Content"
          basicInfo={basicInfo}
          resolutions={previewContent?.source_asset?.progress}
          playIconForVideo={true}
        />
      )}
      <CModalHeader style={{}} className="d-flex flex-column align-items-start px-5 border-0">
        <div className=" w-100 ">
          <p style={{ fontSize: '1.5625vw' }} className="mb-0">
            <b style={{ fontWeight: '500', color: '#191818' }}>{`${
              !listContentMode ? 'SELECT CONTENTS' : 'LIST OF CONTENTS'
            }`}</b>
          </p>
          {!listContentMode && (
            <p style={{ fontSize: '0.9vw' }} className="mb-0">
              <b style={{ fontWeight: '500', color: '#191818' }}>
                Select a list of Contents to create a Static Playlist from Content Library
              </b>
            </p>
          )}
        </div>
      </CModalHeader>
      <CModalBody className="  d-flex flex-column justify-content-between px-5 py-0 ">
        {!listContentMode ? (
          <div>
            <div
              className="d-flex justify-content-center mt-2"
              style={{
                padding: '1.42vw 0vw 0',
                margin: '0 auto 3vh',
                width: '100%',
                visibility: 'unset',
                position: 'relative',
              }}
            >
              <div
                style={{ marginRight: 'auto', fontSize: '14px' }}
                className="d-flex align-items-center"
              >
                <h6>{selectedContents.length} Contents Selected</h6>
              </div>
              <AssetFilter
                filters={filters}
                onSearch={handleSearch}
                onApply={applyFilter}
                onClearAll={resetFilters}
                dropdownHeight={'300px'}
              />
              <div
                className="d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                style={{ border: '0.5px solid #707070' }}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: '100%',
                    backgroundColor: !listView ? '#000' : '#fff',
                    padding: 'max(.42vw,8px) .84vw',
                    cursor: 'pointer',
                  }}
                  onClick={() => setListView(false)}
                >
                  <img
                    src={GridViewIcon}
                    alt=""
                    className="h-100"
                    style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
                  />
                </div>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: '100%',
                    backgroundColor: listView ? '#000' : '#fff',
                    padding: 'max(.42vw,8px) .84vw',
                    cursor: 'pointer',
                  }}
                  onClick={() => setListView(true)}
                >
                  <img
                    src={ListViewIcon}
                    alt=""
                    className="h-100"
                    style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
                  />
                </div>
              </div>
            </div>
            <div id="scrollableDiv" className="asset-manager-card position-relative">
              <Loading
                loading={loader}
                background={'rgba(60, 60, 60, 0.6)'}
                loaderColor="#efefef"
              />
              <InfiniteScroll
                dataLength={contentData.length} //This is important field to render the next data
                next={handleNextPage}
                hasMore={contentList && contentList.total > page * 20}
                style={{ overflowX: 'hidden' }}
                loader={<p>Loading...</p>}
                className="scrollbar-class"
                height={`45vh`}
                scrollableTarget="scrollableDiv"
              >
                {listView && (
                  <div
                    className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute"
                    style={{
                      fontSize: 'max(0.63vw,10px)',
                      gap: '0 2.2%',
                      padding: '2px .6vw',
                      top: '0',
                      zIndex: '10',
                    }}
                  >
                    <div style={{ width: '9%', height: '100%' }}></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ width: '85%' }}
                    >
                      <p style={{ marginBlockEnd: '0', width: '20%' }}>Title</p>
                      <p style={{ marginBlockEnd: '0', width: '10%' }}>Duration</p>
                      <p style={{ marginBlockEnd: '0', width: '10%' }}>Released Date</p>
                      <p style={{ marginBlockEnd: '0', width: '10%' }}>Content Type</p>
                      <p style={{ marginBlockEnd: '0', width: '15%' }}>Category</p>
                      <div style={{ width: '2%' }}></div>
                    </div>
                  </div>
                )}
                <div
                  className="d-flex flex-wrap"
                  style={{
                    gap: listView ? '1.2vw 0' : '1.2vw 1.6%',
                    padding: listView ? '30px 8px 20px 8px' : '20px 8px 20px 8px',
                  }}
                >
                  {!isEmpty(contentData)
                    ? contentData.map((info, index) =>
                        listView ? (
                          <CustomListCard
                            cardImage={getThumbnail(
                              userSessionObj.session_data.cf_domain_name,
                              info?.thumbnail?.website?.s3_key,
                            )}
                            fileName={info?.title}
                            releasedDate={moment(info?.publish_time).format('DD MMM YYYY')}
                            duration={
                              info?.source_asset || info?.live_expiry_time
                                ? info?.source_asset?.file_metadata?.duration
                                  ? convertDuration(info?.source_asset?.file_metadata?.duration)
                                  : moment(info?.live_expiry_time).diff(
                                      moment(info?.publish_time),
                                      'hours',
                                    ) +
                                    'h ' +
                                    (moment(info?.live_expiry_time).diff(
                                      moment(info?.publish_time),
                                      'minutes',
                                    ) %
                                      60) +
                                    'm'
                                : 'N/A'
                            }
                            key={index}
                            contentType={info?.video_type}
                            categories={
                              isArray(info?.category)
                                ? info?.category.map((info) => info.name)
                                : [info?.category.name]
                            } // categories
                            actionButton={'PREVIEW'}
                            actionButtonAction={() => setPreviewContent(info)}
                            isSelectable={true}
                            onSelect={() => handleContentSelect(info)}
                            isMultipleSelectable={true}
                            isSelected={
                              type === 'single'
                                ? selectedContentId === info?._id
                                : selectedContentId.map((item) => item).includes(info?._id)
                            }
                          />
                        ) : (
                          <CustomCard
                            cardImage={getThumbnail(
                              userSessionObj.session_data.cf_domain_name,
                              info?.thumbnail?.website?.s3_key,
                            )}
                            playIconForVideo={true}
                            fileName={info?.title}
                            leftText={info?.video_type}
                            rightText={moment(info?.publish_time).format('DD MMM YYYY')}
                            // if it's a live stream duration will be the streaming duration(differece of live_expiry_time and publish_time)
                            key={index}
                            isSelectable={true}
                            onSelect={() => handleContentSelect(info)}
                            isMultipleSelectable={true}
                            isSelected={
                              type === 'single'
                                ? selectedContentId === info?._id
                                : selectedContentId.map((item) => item).includes(info?._id)
                            }
                            // selectedContents={selectedContents}
                            actionButton={'PREVIEW'}
                            actionButtonAction={() => setPreviewContent(info)}
                          />
                        ),
                      )
                    : !contentListLoading && <h5 className="no-data-text">No Content Found!</h5>}
                </div>
              </InfiniteScroll>
            </div>
            {/* <p
            style={{
              fontSize: 'max(0.73vw,10px)',
              color: '#000',
              marginBlockEnd: '0',
              margin: '20px 0 -29px',
            }}
          >
            * Click individual thumbnails to Add
          </p> */}
          </div>
        ) : (
          <div>
            <div
              className="d-flex justify-content-center"
              style={{
                padding: '1vw 0vw 0',
                margin: '0 auto 3vh',
                width: '100%',
                visibility: 'unset',
                position: 'relative',
              }}
            >
              <div
                style={{ marginRight: 'auto', fontSize: '14px' }}
                className="d-flex align-items-center"
              >
                <h6>{selectedContents.length} Contents linked to the Form</h6>
              </div>
            </div>
            <div id="scrollableDiv" className="asset-manager-card position-relative">
              <InfiniteScroll
                dataLength={selectedContents.length} //This is important field to render the next data
                next={() => {}}
                hasMore={false}
                style={{ overflowX: 'hidden' }}
                loader={<p>Loading...</p>}
                className="scrollbar-class"
                height={`45vh`}
                scrollableTarget="scrollableDiv"
              >
                <div
                  className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute"
                  style={{
                    fontSize: 'max(0.63vw,10px)',
                    gap: '0 2.2%',
                    padding: '2px .6vw',
                    top: '0',
                    zIndex: '10',
                  }}
                >
                  <div style={{ width: '9%', height: '100%' }}></div>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ width: '85%' }}
                  >
                    <p style={{ marginBlockEnd: '0', width: '20%' }}>Title</p>
                    <p style={{ marginBlockEnd: '0', width: '10%' }}>Duration</p>
                    <p style={{ marginBlockEnd: '0', width: '10%' }}>Released Date</p>
                    <p style={{ marginBlockEnd: '0', width: '10%' }}>Content Type</p>
                    <p style={{ marginBlockEnd: '0', width: '15%' }}>Category</p>
                    <div style={{ width: '2%' }}></div>
                  </div>
                </div>
                <div
                  className="d-flex flex-wrap"
                  style={{
                    gap: '1.2vw 0',
                    padding: '30px 8px 20px 8px',
                  }}
                >
                  {selectedContents.map((info, index) => (
                    <CustomPreviewListCard
                      key={index}
                      cardStyle={{ marginBottom: '.8vw', aspectRatio: '1181/71' }}
                      cardImage={getThumbnail(
                        userSessionObj.session_data.cf_domain_name,
                        info?.thumbnail?.website?.s3_key,
                      )}
                      playIconForVideo={true}
                      fileName={info?.title}
                      disableHoverEffect={true}
                      removeSixDotIcon={true}
                      rightText={moment(info?.publish_time).format('DD MMM YYYY')}
                      // if it's a live stream duration will be the streaming duration(differece of live_expiry_time and publish_time)
                      duration={
                        info?.source_asset || info?.live_expiry_time
                          ? info?.source_asset?.file_metadata?.duration
                            ? convertDuration(info?.source_asset?.file_metadata?.duration)
                            : moment(info?.live_expiry_time).diff(
                                moment(info?.publish_time),
                                'hours',
                              ) +
                              'h ' +
                              (moment(info?.live_expiry_time).diff(
                                moment(info?.publish_time),
                                'minutes',
                              ) %
                                60) +
                              'm'
                          : 'N/A'
                      }
                      contentType={info?.video_type}
                      // category={info?.category?.name} // now on categories will go instead of single category
                      categories={
                        isArray(info?.category)
                          ? info?.category.map((info) => info.name)
                          : [info?.category.name]
                      } // categories
                      actionButtonAction={() => handleRemoveContent(info._id)}
                      fileNameWidth="20%"
                      categoriesWidth="15%"
                    />
                  ))}
                </div>
              </InfiniteScroll>
            </div>
          </div>
        )}
      </CModalBody>
      <CModalFooter style={{ border: 'none' }} className=" px-5">
        <CButton
          className=""
          style={{
            color: '#3a3838',
            backgroundColor: 'white',
            marginRight: '1.5rem',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={() => setContentModalNewProps({})}
        >
          Cancel
        </CButton>
        <CButton
          color="info"
          className="text-white"
          style={{
            color: 'white',
            backgroundColor: '#20211c',
            border: '1px solid #bdbdbd',
            borderRadius: '5px',
          }}
          onClick={listContentMode ? () => handleSelect() : () => handleContentMode()}
        >
          {/* {playlistPreview ? 'Save' : 'Preview'} */}
          {'Save & Next'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ContentModalNew
